import { render } from "./sortNew.vue?vue&type=template&id=2e985570&scoped=true"
import script from "./sortNew.vue?vue&type=script&lang=js"
export * from "./sortNew.vue?vue&type=script&lang=js"

import "./sortNew.vue?vue&type=style&index=0&id=2e985570&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e985570"]])

export default __exports__